import React from "react";
import { Container, Card, CardBody } from "reactstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { SUPPORT_EMAIL } from "../components/Footer";
import "./ContactPage.css";

const SupportPage = () => (
  <>
    <Navbar />
    <main className="hn-contact-main">
      <Container className="py-4 py-md-5">
        <h1 className="hn-contact-title">Support</h1>
        <p className="hn-contact-intro text-muted mb-4">
          Need help with your service or account? We aim to respond within 24 hours. Support is available Mon–Fri, 9am–5pm GMT.
        </p>
        <Card className="hn-contact-card" style={{ maxWidth: "32rem" }}>
          <CardBody className="p-4">
            <div className="hn-contact-icon-wrap mb-3">
              <i className="fas fa-headset hn-contact-icon" aria-hidden="true" />
            </div>
            <h2 className="hn-contact-heading">Get in touch</h2>
            <p className="text-muted mb-3">
              For technical support, billing questions, or general enquiries, email us at:
            </p>
            <a href={`mailto:${SUPPORT_EMAIL}`} className="hn-contact-email">
              {SUPPORT_EMAIL}
            </a>
            <p className="small text-muted mt-2 mb-0">
              We aim to respond within 24 hours.
            </p>
          </CardBody>
        </Card>
      </Container>
    </main>
    <Footer />
  </>
);

export default SupportPage;
